import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useNotify } from 'react-admin';

/**
 * STORES.jpからのOAuthコールバックを処理するカスタムフック
 * @returns {boolean} 連携処理中かどうかを示すisLoadingフラグ
 */
export const useOAuthCallback = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const notify = useNotify();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');

    // 'code'が存在する場合のみ、OAuth連携処理を実行
    if (code) {
      setIsLoading(true);
      console.log('Authorization code found, processing with hook:', code);

      // バックエンドのAPIエンドポイントにcodeを送信
      fetch('/api/stores/callback', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code })
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('連携処理に失敗しました。');
          }
          return response.json();
        })
        .then((data) => {
          notify('STORES.jpとの連携が完了しました。', { type: 'success' });
          navigate('/');
        })
        .catch((error) => {
          console.error('OAuth callback error:', error);
          notify(error.message || '連携中に不明なエラーが発生しました。', { type: 'error' });
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [location, navigate, notify]);

  return { isLoading };
};
